/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import { Card, IconArrowDown, IconArrowUp } from 'uikit';

import type React from 'react';
import { Children, useCallback, useEffect, useState } from 'react';

import Styles from './SideDetailsLayout.module.css';

interface ISideDetailsLayout {
    onDetailsVisibilityChange: (isVisible: boolean) => void;
    expandedTitle?: string;
    collapsedTitle?: string;
    switchStyle?: React.CSSProperties;
}

export const SideDetailsLayout: React.FC<ISideDetailsLayout> = (props): JSX.Element => {
    const {
        onDetailsVisibilityChange,
        expandedTitle = 'Закрыть',
        collapsedTitle = 'Открыть',
        children,
        switchStyle,
    } = props;
    const [isExpanded, setIsExpanded] = useState(false);
    const childrenAsArray = Children.toArray(children);

    useEffect(() => {
        onDetailsVisibilityChange(isExpanded);
    }, [isExpanded, onDetailsVisibilityChange]);

    const onSwitcherClick = useCallback(() => {
        setIsExpanded((prevState) => !prevState);
    }, []);

    return (
        <div className={Styles.sideDetailsLayout}>
            <div className={`${Styles.sideDetailsLayoutMainSide} ${isExpanded ? Styles.withDetails : ''}`}>
                {childrenAsArray[0]}
            </div>
            <div
                className={Styles.sideDetailsLayoutDetailsSideVisibilitySwitcher}
                onClick={onSwitcherClick}
                style={switchStyle}
            >
                <div className={Styles.sideDetailsLayoutDetailsSideVisibilitySwitcherTitle}>
                    {isExpanded ? expandedTitle : collapsedTitle}
                    {isExpanded ? (
                        <IconArrowDown size="xs" className={Styles.arrow} />
                    ) : (
                        <IconArrowUp size="xs" className={Styles.arrow} />
                    )}
                </div>
            </div>
            <div
                className={`${Styles.sideDetailsLayoutDetailsSide} ${!isExpanded ? Styles.hidden : ''}`}
                style={switchStyle}
            >
                <Card style={{ width: '100%', overflowY: 'scroll' }}>{childrenAsArray[1]}</Card>
            </div>
        </div>
    );
};

SideDetailsLayout.displayName = 'SideDetailsLayout';
